// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// Použij StrictMode jen v produkci (v devu zabrání dvojímu mountu/effectům)
const useStrict = process.env.NODE_ENV === "production";

root.render(
  useStrict ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);

// Volitelné: měření výkonu
reportWebVitals();
